var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsultancy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "consultancy",
    transform: "translate(-15.996 -23.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4962",
    "data-name": "Path 4962",
    d: "M84.093,210.077a4.652,4.652,0,0,0-6.1-.438l-5.721,4.34-1.033-3.135a4.113,4.113,0,0,0-5.214-2.639,4.155,4.155,0,0,0-2.74,3.139l-2.12,10.721L52.294,233.28H43.066a7.627,7.627,0,0,0,.43-2.529v-3.495l1.056-.534a7.187,7.187,0,0,0,3.944-6.456v-4.689a2.515,2.515,0,0,0-2.5-2.529H34.564A8.618,8.618,0,0,0,26,221.716a8.746,8.746,0,0,0,.9,3.876l1.6,3.227v4.461A12.587,12.587,0,0,0,16,245.924v53.105h5V282.8a19.436,19.436,0,0,0,2.888,2.646l4.739,14.381,4.744-1.6-5-15.173a2.525,2.525,0,0,0-.985-1.3,14.5,14.5,0,0,1-6.3-10.54H41v27.817h5V268.994l4.452-18.013h7.245a12.5,12.5,0,0,0,10.853-6.371l16.3-28.853a4.773,4.773,0,0,0-.752-5.681Zm-49.529,8.03H43.5v2.16a2.15,2.15,0,0,1-1.18,1.932l-2.438,1.233h0a3.073,3.073,0,0,1-4.145-1.4h0a2.485,2.485,0,0,0-4-.657l-.71.718a3.653,3.653,0,0,1-.022-.379,3.593,3.593,0,0,1,3.568-3.609ZM33.5,227.074a8.105,8.105,0,0,0,5,1.749v1.928a2.5,2.5,0,1,1-5,0Zm8.048,39.08H21V245.924a7.552,7.552,0,0,1,7.5-7.586H41v7.586H33.5v5.058h11.8ZM64.2,242.1a7.5,7.5,0,0,1-6.512,3.822H46v-7.586h7.5a2.489,2.489,0,0,0,1.952-.949l10-12.644a2.541,2.541,0,0,0,.5-1.084l1.591-8.048,1.085,3.294A2.487,2.487,0,0,0,72.5,220.13l7.211-5.471Z",
    transform: "translate(0 -125.835)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4963",
    "data-name": "Path 4963",
    d: "M391.5,295.167a7.587,7.587,0,1,0-7.5-7.586A7.544,7.544,0,0,0,391.5,295.167Zm0-10.115a2.529,2.529,0,1,1-2.5,2.529A2.515,2.515,0,0,1,391.5,285.052Z",
    transform: "translate(-253 -175.078)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4964",
    "data-name": "Path 4964",
    d: "M360,343.994h12.5v5.058H360Z",
    transform: "translate(-236.5 -218.847)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4965",
    "data-name": "Path 4965",
    d: "M416,343.994h12.5v5.058H416Z",
    transform: "translate(-275 -218.847)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4966",
    "data-name": "Path 4966",
    d: "M376,375.994h20v5.058H376Z",
    transform: "translate(-247.5 -240.732)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4967",
    "data-name": "Path 4967",
    d: "M352,407.994h7.5v5.058H352Z",
    transform: "translate(-231 -262.617)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4968",
    "data-name": "Path 4968",
    d: "M352,439.994h15v5.058H352Z",
    transform: "translate(-231 -284.501)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4969",
    "data-name": "Path 4969",
    d: "M392,407.994h5v5.058h-5Z",
    transform: "translate(-258.5 -262.617)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4970",
    "data-name": "Path 4970",
    d: "M424,407.994h12.5v5.058H424Z",
    transform: "translate(-280.5 -262.617)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4971",
    "data-name": "Path 4971",
    d: "M440,439.994h7.5v5.058H440Z",
    transform: "translate(-291.5 -284.501)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4972",
    "data-name": "Path 4972",
    d: "M285.453,232.187a2.479,2.479,0,0,0-2.725.548L279.5,236l-3.232-3.27a2.481,2.481,0,0,0-3.536,0L269.5,236l-3.232-3.27a2.481,2.481,0,0,0-3.536,0L259.5,236l-3.232-3.27a2.481,2.481,0,0,0-3.536,0L249.5,236l-3.232-3.27a2.481,2.481,0,0,0-3.536,0L239.5,236l-3.232-3.27a2.48,2.48,0,0,0-3.536,0,2.544,2.544,0,0,0-.732,1.788v20.231H204.5A12.587,12.587,0,0,0,192,267.4v27.817a2.544,2.544,0,0,0,.732,1.788l5,5.058a2.481,2.481,0,0,0,3.536,0l3.232-3.269,3.232,3.269a2.481,2.481,0,0,0,3.536,0l.732-.741V302.8a12.587,12.587,0,0,0,12.5,12.644h50A12.587,12.587,0,0,0,287,302.8V234.523A2.529,2.529,0,0,0,285.453,232.187ZM212,294.167l-2.5,2.529-3.232-3.27a2.48,2.48,0,0,0-3.536,0L199.5,296.7l-2.5-2.529V267.4a7.5,7.5,0,1,1,15,0Zm12.5,16.22A7.552,7.552,0,0,1,217,302.8V267.4a12.672,12.672,0,0,0-2.507-7.586H232V302.8A7.552,7.552,0,0,1,224.5,310.387ZM282,302.8a7.552,7.552,0,0,1-7.5,7.586H234.49A12.677,12.677,0,0,0,237,302.8V240.628l.732.741a2.481,2.481,0,0,0,3.536,0L244.5,238.1l3.232,3.269a2.481,2.481,0,0,0,3.536,0L254.5,238.1l3.232,3.269a2.481,2.481,0,0,0,3.536,0L264.5,238.1l3.232,3.269a2.481,2.481,0,0,0,3.536,0L274.5,238.1l3.232,3.269a2.481,2.481,0,0,0,3.536,0l.732-.741Z",
    transform: "translate(-121 -142.251)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4973",
    "data-name": "Path 4973",
    d: "M400,23.994H360v5.058h37.5V74.57H360v5.058h40a2.515,2.515,0,0,0,2.5-2.529V26.523A2.515,2.515,0,0,0,400,23.994Z",
    transform: "translate(-236.5 0)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4974",
    "data-name": "Path 4974",
    d: "M218.5,23.994h-40a2.515,2.515,0,0,0-2.5,2.529V77.1a2.515,2.515,0,0,0,2.5,2.529h40V74.57H181V29.052h37.5Z",
    transform: "translate(-110 0)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4975",
    "data-name": "Path 4975",
    d: "M256,103.994h7.5v5.058H256Z",
    transform: "translate(-165 -54.712)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4976",
    "data-name": "Path 4976",
    d: "M240.5,55.994H218a2.515,2.515,0,0,0-2.5,2.529V63.58a2.517,2.517,0,0,1-2.5,2.529h-2.5a2.515,2.515,0,0,0-2.5,2.529V78.753a2.515,2.515,0,0,0,2.5,2.529H213a2.517,2.517,0,0,1,2.5,2.529v5.058A2.515,2.515,0,0,0,218,91.4h22.5V86.34h-20V83.811a7.552,7.552,0,0,0-7.5-7.586V71.167a7.552,7.552,0,0,0,7.5-7.586V61.052h20Z",
    transform: "translate(-132 -21.885)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4977",
    "data-name": "Path 4977",
    d: "M382.5,55.994H360v5.058h20V63.58a7.552,7.552,0,0,0,7.5,7.586v5.058a7.552,7.552,0,0,0-7.5,7.586V86.34H360V91.4h22.5a2.515,2.515,0,0,0,2.5-2.529V83.811a2.517,2.517,0,0,1,2.5-2.529H390a2.515,2.515,0,0,0,2.5-2.529V68.638a2.515,2.515,0,0,0-2.5-2.529h-2.5A2.518,2.518,0,0,1,385,63.58V58.523A2.515,2.515,0,0,0,382.5,55.994Z",
    transform: "translate(-236.5 -21.885)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4978",
    "data-name": "Path 4978",
    d: "M392,103.994h7.5v5.058H392Z",
    transform: "translate(-258.5 -54.712)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4979",
    "data-name": "Path 4979",
    d: "M328,47.994h5v5.058h-5Z",
    transform: "translate(-214.5 -16.414)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4980",
    "data-name": "Path 4980",
    d: "M328,79.994h5v5.058h-5Z",
    transform: "translate(-214.5 -38.298)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4981",
    "data-name": "Path 4981",
    d: "M328,111.994h5v5.058h-5Z",
    transform: "translate(-214.5 -60.183)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4982",
    "data-name": "Path 4982",
    d: "M328,143.994h5v5.058h-5Z",
    transform: "translate(-214.5 -82.068)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4983",
    "data-name": "Path 4983",
    d: "M328,175.994h5v5.058h-5Z",
    transform: "translate(-214.5 -103.952)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4984",
    "data-name": "Path 4984",
    d: "M328,207.994h5v5.058h-5Z",
    transform: "translate(-214.5 -125.837)",
    fill: "#ff725e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultancy);
export default __webpack_public_path__ + "static/media/consultancy.11339fb7c8ffe3a0c7ad4ba142817db6.svg";
export { ForwardRef as ReactComponent };